/**
 * Fields owned by the builder "Detalii produs" section.
 * Direct "Salvează în listă" is allowed only when changes are limited to these.
 */
export const PRODUCT_DETAILS_KEYS = [
    'productName',
    'measurementUnit',
    'weight',
    'nomenclatureCode',
    'productNotes',
    'isCompositeProduct',
    'componentProductCodes',
    'componentProductsKeepInList',
    'visibleInOfferApp',
    'status',
];

const PRODUCT_DETAILS_KEY_SET = new Set(PRODUCT_DETAILS_KEYS);

/**
 * @param {string} fieldKey
 * @returns {boolean}
 */
export function isProductDetailsDirectSaveField(fieldKey) {
    return PRODUCT_DETAILS_KEY_SET.has(String(fieldKey || '').trim());
}
